import React from 'react';
import renderHTML from 'react-render-html';
import PlanItem from '../plan-item/plan-item';
import './plan-details.css';

const PlanDetails = (props) => {
  const {
    planOverview: {
      description,
      plan1,
      plan2,
      plan3,
      footerText,
    },
  } = props;
  return (
    <div className="plan-details-section">
      <div className="row">
        <div className="col-12">
          {renderHTML(description)}
        </div>
      </div>
      <div className="row plan-details">
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan1} customClass="plan-lite" />
        </div>
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan2} customClass="plan-mid" />
        </div>
        <div className="col-sm-12 col-md-4 plan-details-item">
          <PlanItem item={plan3} customClass="plan-max" />
        </div>
      </div>
      <div className="row">
        <div className="col-12 footer-text">
          {renderHTML(footerText)}
        </div>
      </div>
    </div>
  );
};

export default PlanDetails;
